export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "在178漫画网阅读《满溢游泳池》需要付费吗？",
    a: "不需要。178漫画网提供完全免费的漫画在线阅读服务，《满溢游泳池》全集中文故事均可免费浏览，无需付费或注册即可享受完整章节与高清画面。",
  },
  {
    q: "《满溢游泳池》多久更新一集？",
    a: "《满溢游泳池》目前每周更新一话，通常于每周六晚更新。你可以通过首页的「最新章节」和「更新推荐」板块第一时间看到最新更新。",
  },
  {
    q: "漫画可以直接在手机上阅读吗？",
    a: "可以。178漫画网支持电脑、平板和手机等多种设备在线浏览，页面会自适应屏幕大小，竖屏阅读体验更佳。",
  },
  {
    q: "如何按分类查找喜欢的漫画？",
    a: "你可以在顶部导航进入「分类」页面，或直接点击首页的分类入口，根据恋爱、校园、日常、治愈、搞笑、运动等题材筛选喜欢的漫画作品。",
  },
  {
    q: "阅读漫画需要注册账号吗？",
    a: "不需要。178漫画网的所有漫画内容都支持免登录免费阅读，方便你随时开启轻松的追漫时光。",
  },
  {
    q: "遇到漫画加载异常怎么办？",
    a: "如果遇到图片加载缓慢或异常，请尝试刷新页面或更换网络环境。若问题持续存在，可通过「关于我们」页面提供的联系方式反馈给我们的客服团队。",
  },
];

export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  cover: string;
  tags: string[];
}

export const newsArticles: Article[] = [
  {
    id: "news-1",
    slug: "man-yi-ji-duan-ping-ce",
    title: "盛夏高分恋爱漫画《满溢游泳池》深度评测",
    summary: "从剧情节奏、人物刻画到画风表现，全方位解读为何《满溢游泳池》会成为今年夏天口碑最好的恋爱漫画之一。",
    category: "评测",
    date: "2026-08-10",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20sparkling%20summer%20swimming%20pool%20with%20floating%20light%20bokeh%20and%20soft%20coral%20sunset%20light%2C%20dreamy%20editorial%20artwork%2C%20clean%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=news-review-01&orientation=landscape",
    tags: ["评测", "满溢游泳池"],
  },
  {
    id: "news-2",
    slug: "man-yi-li-ju",
    title: "《满溢游泳池》人气票选：你最喜欢哪一话？",
    summary: "「池边的告白」「夏日终曲」「深水区」……连载至今，哪一话最让你心动？参与人气投票，看看大家共同的追漫回忆。",
    category: "互动",
    date: "2026-08-06",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20colorful%20voting%20ballot%20box%20with%20sparkles%20and%20floating%20bubbles%20near%20a%20swimming%20pool%2C%20cheerful%20coral%20and%20teal%20tone%2C%20clean%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=news-vote-02&orientation=landscape",
    tags: ["互动", "人气票选"],
  },
  {
    id: "news-3",
    slug: "qiu-ji-zui-xin",
    title: "秋季新番前瞻：多部恋爱新作即将上线",
    summary: "随着夏日接近尾声，178漫画网即将上线多部备受期待的恋爱与校园新作，抢先预览你最不该错过的秋季漫画片单。",
    category: "资讯",
    date: "2026-08-01",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20an%20autumn%20campus%20with%20falling%20maple%20leaves%20and%20soft%20warm%20golden%20light%2C%20cozy%20and%20nostalgic%20mood%2C%20coral%20and%20amber%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=news-autumn-03&orientation=landscape",
    tags: ["资讯", "秋季新番"],
  },
  {
    id: "news-4",
    slug: "du-zhe-zhi-liao",
    title: "读者投稿：那些被漫画治愈的瞬间",
    summary: "在快节奏的生活里，漫画是我们小小的避风港。收集了读者们被《满溢游泳池》等治愈系作品感动与治愈的温暖留言。",
    category: "栏目",
    date: "2026-07-25",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20cozy%20reading%20corner%20with%20open%20books%20and%20a%20warm%20lamp%2C%20soft%20cream%20and%20coral%20tones%2C%20warm%20healing%20atmosphere%2C%20clean%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=news-heal-04&orientation=landscape",
    tags: ["栏目", "治愈"],
  },
];